export default "__VITE_ASSET__BaJ4g4UW__"